/*
 * VirtualList  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { Virtuoso } from "react-virtuoso";

export interface IVirtualListProps extends React.ComponentProps<typeof Virtuoso> {}

export const VirtualList: React.FC<IVirtualListProps> = (props) => <Virtuoso {...props} />;
